import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyAboutSectionComponent } from '../../../sections/property-default-sections/property-about-section/property-about-section.component';
import { PropertyRentalAttributeSectionComponent } from '../../../sections/residential-for-rent/property-rental-attribute-section/property-rental-attribute-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    templateUrl: './property-description-page.component.html',
    styleUrls: ['./property-description-page.component.scss']
})
export class ResidentialForRentPropertyDescriptionComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    sideCardIcon = '/sell/property/assets/property-ui/hands.svg';
    sideCardHeading =
        'Feeling stuck? Here’s a few things renters are looking for:';

    @ViewChild(PropertyAboutSectionComponent, {
        read: PropertyAboutSectionComponent
    })
    propertyAboutSectionComponent: PropertyAboutSectionComponent;

    @ViewChild(PropertyRentalAttributeSectionComponent, {
        read: PropertyRentalAttributeSectionComponent
    })
    propertyRentalAttributeSectionComponent: PropertyRentalAttributeSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyDescription, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyAboutSectionComponent);
        super.registerSection(this.propertyRentalAttributeSectionComponent);
    }
}
